const isObject = (value) => value && typeof value === 'object';

const EXPLICIT_DATA_KEYS = new Set(['cy', 'intercom-target', 'create-btn']);
const SVG_ELEMENTS_WITH_NATIVE_CY = new Set([
  'circle',
  'ellipse',
  'feDropShadow',
  'filter',
  'foreignObject',
  'image',
  'mask',
  'pattern',
  'radialGradient',
  'rect',
  'svg',
  'text',
  'tspan',
  'use',
]);

const shouldKeepNativeProp = (type, key) =>
  typeof type === 'string' && key === 'cy' && SVG_ELEMENTS_WITH_NATIVE_CY.has(type);

const collectDataEntries = (type, props) => {
  const entries = [];

  if (isObject(props.dataSet)) {
    entries.push(...Object.entries(props.dataSet));
  }

  Object.keys(props).forEach((key) => {
    if (!EXPLICIT_DATA_KEYS.has(key) || shouldKeepNativeProp(type, key)) {
      return;
    }

    entries.push([key, props[key]]);
  });

  return entries;
};

const mapDataProps = (type, props) => {
  if (!props || !isObject(props)) {
    return props;
  }

  const dataEntries = collectDataEntries(type, props).filter(([, value]) => value !== undefined && value !== null);
  if (!dataEntries.length) {
    return props;
  }

  const dataProps = dataEntries.reduce((acc, [key, value]) => {
    acc[`data-${key}`] = value;
    return acc;
  }, {});

  if (typeof type === 'string') {
    const { dataSet, ...rest } = props;
    const cleaned = { ...rest };
    EXPLICIT_DATA_KEYS.forEach((key) => {
      if (shouldKeepNativeProp(type, key)) {
        return;
      }

      delete cleaned[key];
    });

    return {
      ...dataProps,
      ...cleaned,
    };
  }

  return {
    ...dataProps,
    ...props,
  };
};

export default mapDataProps;
